import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import classNames from "classnames";
import { PaginationProps } from "./types";
import classes from "./Pagination.module.scss";

export const Pagination = ({ className, totalPages, currentPage }: PaginationProps) => {
    const router = useRouter();

    const createPaginationLinks = () => {
        let pages = [];

        const maxVisiblePages = 12;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            const isFarFromActive = Math.abs(currentPage - i) > 3;

            pages.push(
                <li
                    key={i}
                    className={classNames(classes.pagination__item, {
                        [classes["pagination__item--active"]]: i === currentPage,
                        [classes["pagination__item--hidden"]]: isFarFromActive
                    })}
                >
                    <Link
                        className={classNames(classes.pagination__link)}
                        href={
                            i === 1
                                ? { pathname: router.pathname }
                                : { pathname: router.pathname, query: { ...router.query, page: i } }
                        }
                    >
                        {i}
                    </Link>
                </li>
            );
        }

        return pages;
    };

    const prevPageHref =
        currentPage - 1 === 1
            ? { pathname: router.pathname }
            : { pathname: router.pathname, query: { ...router.query, page: currentPage - 1 } };

    const nextPageHref = {
        pathname: router.pathname,
        query: { ...router.query, page: currentPage + 1 }
    };

    return (
        <div className={classNames(classes.pagination, className)}>
            <div
                className={classNames(classes.pagination__control, {
                    [classes["pagination__item--disabled"]]: currentPage === 1
                })}
            >
                {currentPage > 1 ? (
                    <Link
                        className={classNames(classes.pagination__link)}
                        href={prevPageHref}
                        aria-label="Назад"
                    >
                        Назад
                    </Link>
                ) : (
                    <span>Назад</span>
                )}
            </div>
            <ul className={classes.pagination__inner}>{createPaginationLinks()}</ul>
            <div
                className={classNames(classes.pagination__control, {
                    [classes["pagination__item--disabled"]]: currentPage === totalPages
                })}
            >
                {currentPage < totalPages ? (
                    <Link
                        className={classNames(classes.pagination__link)}
                        href={nextPageHref}
                        aria-label="Далее"
                    >
                        Далее
                    </Link>
                ) : (
                    <span>Далее</span>
                )}
            </div>
        </div>
    );
};